export const RECURSIVE_FREQUENCIES = ['Daily', 'Weekly', 'Monthly'];

export const DAILY_DAY_OPTIONS = [
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
  { value: 7, label: 'Sunday' },
];

export const WEEKLY_DAY_OPTIONS = [
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
];

export function getDaysInMonth(year, monthIndex) {
  return new Date(year, monthIndex + 1, 0).getDate();
}

/** Monthly day options (1..28/29/30/31) for the month of referenceDate or due date. */
export function getMonthlyDayOptions(referenceDate = new Date()) {
  const d = referenceDate instanceof Date ? referenceDate : new Date(referenceDate);
  if (Number.isNaN(d.getTime())) {
    const now = new Date();
    return buildMonthlyOptions(now.getFullYear(), now.getMonth());
  }
  return buildMonthlyOptions(d.getFullYear(), d.getMonth());
}

function buildMonthlyOptions(year, monthIndex) {
  const count = getDaysInMonth(year, monthIndex);
  return Array.from({ length: count }, (_, i) => ({
    value: i + 1,
    label: String(i + 1),
  }));
}

export function getRecursiveValueOptions(frequency, referenceDate = new Date()) {
  switch (frequency) {
    case 'Daily':
      return DAILY_DAY_OPTIONS;
    case 'Weekly':
      return WEEKLY_DAY_OPTIONS;
    case 'Monthly':
      return getMonthlyDayOptions(referenceDate);
    default:
      return [];
  }
}

export function normalizeRecursiveFrequency(value) {
  if (!value) return '';
  const trimmed = String(value).trim();
  const match = RECURSIVE_FREQUENCIES.find(
    (f) => f.toLowerCase() === trimmed.toLowerCase()
  );
  return match || '';
}
